import type { CSSProperties, ReactNode } from "react";
import { offsetShadow, TYPE } from "@chess/shared";
import { useTheme } from "@/theme/ThemeProvider";

interface Props {
  children: ReactNode;
  padding?: number;
  shadowSize?: number;
  label?: ReactNode;
  bg?: string;
  fg?: string;
  borderColor?: string;
  style?: CSSProperties;
}

export function BrBox({
  children,
  padding = 20,
  shadowSize = 6,
  label,
  bg,
  fg,
  borderColor,
  style = {},
}: Props) {
  const p = useTheme();
  return (
    <div
      style={{
        background: bg || p.card,
        color: fg || p.fg,
        border: `2px solid ${borderColor || p.border}`,
        boxShadow: offsetShadow(p, shadowSize, shadowSize),
        padding,
        position: "relative",
        fontFamily: TYPE.body,
        transition: "background .25s, color .25s, border-color .25s, box-shadow .25s",
        ...style,
      }}
    >
      {label && (
        <div
          style={{
            position: "absolute",
            top: -2,
            left: 16,
            transform: "translateY(-100%)",
            background: p.fg,
            color: p.bg,
            padding: "3px 9px",
            fontSize: 10,
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: 1.2,
            fontFamily: TYPE.mono,
            border: `2px solid ${p.border}`,
            borderBottom: "none",
          }}
        >
          {label}
        </div>
      )}
      {children}
    </div>
  );
}
